import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import GenericInlineEdit from '../../common/GenericInlineEdit';
import { useDispatch } from '../../common/react-redux-hooks';
import { editClusterSegmentName } from '../../../actions/cacActions';
import { corrChartColors } from '../enhancedFeatures/clusterColors';
import styled from 'styled-components';

const SegDiv = styled.div`
  border-radius: 50%;
  margin-right: 6px;
  align-self: center;
  background-color: ${props => corrChartColors[props.cIndex - 1].color};
  width: 16px;
  height: 16px;
`;

const SegmentNotablecard = props => {
  const { segmentCardData, index } = props;
  const dispatch = useDispatch();
  return (
    <div className="segment-notable-card" data-test="segment-notable-card">
      <div className="card-header">
        <SegDiv cIndex={+segmentCardData.segmentId} />
        <div className="card-header-left" title={segmentCardData.segmentName}>
          <GenericInlineEdit
            data-test="inlineEditComponent"
            validate={text => text.length > 0 && text.length < 1024}
            activeClassName="editing"
            text={segmentCardData.segmentName}
            paramName="newSegmentName"
            style={{
              backgroundColor: 'rgba(121, 148, 187, 0.2)',
              color: '#000000',
              border: 'none',
              borderRadius: '5px',
              height: '25px',
              padding: '4px',
              width: '100%',
            }}
            change={updatedObjectProps =>
              dispatch(
                editClusterSegmentName(updatedObjectProps.newSegmentName, index)
              )
            }
          />
        </div>
        <div className="card-header-right">
          <p>Segment Size: {Math.round(segmentCardData.pct)}%</p>
          <p>Sample Size: {segmentCardData.sample}</p>
        </div>
      </div>
      <div className="card-body">
        {segmentCardData.notableCharacterstics.map(item => (
          <p key={uuid()} className="card-body-statement">
            <span className="card-body-statement-text">{item.text}</span>
            <span
              className="card-body-statement-index"
              style={{ color: item.index < 100 ? '#ee3232' : '#00b400' }}
            >
              {item.index}
            </span>
          </p>
        ))}
      </div>
    </div>
  );
};

SegmentNotablecard.propTypes = {
  segmentCardData: PropTypes.instanceOf(Object),
  index: PropTypes.number,
};

export default SegmentNotablecard;